import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiDataList, TuiDropdown, TuiButton, TuiHint } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from '@src/app/modules/icon';
import { ComponentsModule } from '@src/app/components';

import { ActionsComponent } from './actions.component';
import { ViewIconsComponent } from './view-icons/view-icons.component';
import { ViewMenuComponent } from './view-menu/view-menu.component';
import { ViewDataListComponent } from './view-data-list/view-data-list.component';

@NgModule({
  declarations: [ActionsComponent, ViewIconsComponent, ViewMenuComponent, ViewDataListComponent],
  imports: [
    CommonModule,
    TuiButton,
    ...TuiDataList,
    ...TuiDropdown,
    ...TuiHint,
    IconModule,
    ComponentsModule,
    TranslateModule,
  ],
  exports: [ActionsComponent],
})
export class ActionsModule {}
